export default class LocalStorage {
    static setItem(key: string, value: string) {
        window.localStorage.setItem(key, value);
    }
    
    static getItem(key: string): string | null {
        if (key === 'i18nextLng') {
            const lang = window.localStorage.getItem(key) ?? 'vi';
            if (lang !== 'vi' && lang !== 'en')
                return 'vi';
            return lang;
        }
        return window.localStorage.getItem(key);
    }
    
    static getToken(): string | null {
        return window.localStorage.getItem('accessToken') || window.localStorage.getItem('token');
    }
    
    static setToken(token: string) {
        window.localStorage.setItem('accessToken', token);
        // Backwards compatibility
        window.localStorage.setItem('token', token);
    }
    
    static delete(key: string) {
        window.localStorage.removeItem(key);
    }
    
    static deleteToken() {
        window.localStorage.removeItem('accessToken');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('refreshToken');
    }
    
    static clear() {
        window.localStorage.clear();
    }
    
    // Helper methods for common items
    static getRefreshToken(): string | null {
        return window.localStorage.getItem('refreshToken');
    }
    
    static setRefreshToken(token: string) {
        window.localStorage.setItem('refreshToken', token);
    }
    
    static getUserInfo(): any | null {
        const userInfo = window.localStorage.getItem('userInfo');
        try {
            return userInfo ? JSON.parse(userInfo) : null;
        } catch (error) {
            return null;
        }
    }
    
    static setUserInfo(userInfo: any) {
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
    
    static deleteUserInfo() {
        window.localStorage.removeItem('userInfo');
    }
}